
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LightbulbIcon } from 'lucide-react';

export const AnalysisTip = () => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <LightbulbIcon className="h-5 w-5 text-yellow-500" />
          Analysis Tips
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 pt-0 text-sm">
        <p>
          For best results, submit longer text samples (at least several paragraphs).
        </p>
        <p>
          Our detection is most accurate with English language text longer than 300 words.
        </p>
        <p>
          Try different models if the initial results seem inconclusive. Each has different strengths.
        </p>
      </CardContent>
    </Card>
  );
};
